import * as z from "zod";

export const getGuidance = {
  name: "getGuidance" as const,
  input: z.object({}),
  output: z.object({ guidance: z.string().nullable() }),
};
